import React from 'react'
import { shape, string } from 'prop-types'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { useAtSize } from '@fs/zion-ui'
import TextRibbon from '../../../../../../../TextRibbon/TextRibbon'
import { getGender } from '../../../../../../../../helpers/person_Helper'

const cssItem = css`
  height: 150px;
  list-style: none;
`

const cssItemWrap = css`
  border-right: 2px solid #222;
  height: 100%;
  width: 20%;
  float: left;
  padding-right: 15px;
  padding-top: 5px;
  text-align: right;
`

const cssClear = css`
  clear: both;
`

const cssEventItem = css`
  float: left;
  width: 80%;
`

const cssEventText = css`
  margin-left: 32px;
  margin-top: 2px;
`

export default function PersonTimelineItem({ gender, deathYear, age, year, description, event }) {
  gender = getGender(gender)
  const { t } = useTranslation()
  const atSize = useAtSize()
  const ageLabel = t('wcf.person-header.age.living', 'Age')

  let cssBulletColor = '#aaa'
  if (gender === 'male') {
    cssBulletColor = '#7de3f4'
  } else if (gender === 'female') {
    cssBulletColor = '#fc4e6d'
  }

  const cssBullet = css`
    background-color: ${cssBulletColor};
    margin-left: -11px;
    margin-top: 5px;
    float: left;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    border: 2px solid #000;
  `

  const cssAge = css`
    color: #aaa;
    margin-top: 8px;
    ${atSize({ default: 'font-size: 0.8rem', sm: 'font-size: 1rem' })};
  `

  const cssDescription = css`
    display: inline-block;
    line-height: 1.4;
    margin-top: 5px;
    ${atSize({ default: 'font-size: 0.8rem', sm: 'font-size: 1rem' })};
  `

  const AgeItem = () => {
    let calcAge = null
    if (age !== null && age > 0 && deathYear && year <= deathYear) {
      calcAge = (
        <div css={cssAge}>
          {ageLabel} {age}
        </div>
      )
    }
    return calcAge
  }

  const timelineItem = (
    <li css={cssItem}>
      <div css={cssItemWrap}>
        <div>{`${year}`} </div>
        <AgeItem />
      </div>
      <div css={cssEventItem}>
        <div css={cssBullet} />
        <div css={cssEventText}>
          <TextRibbon type="arrow-ribbon" backgroundColor="#000" color="#fff">
            {event}
          </TextRibbon>
          <div css={cssDescription}>{description}</div>
        </div>
        <div css={cssClear} />
      </div>
      <div css={cssClear} />
    </li>
  )

  return timelineItem
}

PersonTimelineItem.propTypes = {
  ancestor: shape({
    name: string,
  }),
  name: string,
}
